import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import payStackImg from "../assets/images/paystack.png";
import SocialLinks from "./SocialLinks";
import { productCategories } from "../assets/data/categories";
// import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const links = [
    { name: "About us", link: "/about" },
    { name: "Products", link: "/products" },
    { name: "Services", link: "/services" },
    { name: "Training", link: "/training" },
    { name: "News", link: "/news" },
    { name: "Contact us", link: "/contact" },
    { name: "My Account", link: "/account" },
    { name: "Privacy Policy", link: "/privacy-policy" },
    { name: "Terms and Conditions", link: "/terms&conditions" },
  ];

  return (
    <div className="footer">
      <div className="footer__main">
        <div className="footer__main__logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
          <p style={{ marginBottom: 20 }}>
            Chaol Carington Ltd is a CAC-registered company based in Nigeria,
            focused on improving medical and surgical equipment services through
            sales, fabrication, capacity building of technicians and special
            need’s caregivers
          </p>
          <SocialLinks alt={true} />
        </div>

        <div className="footer__main__item">
          <h4>Links</h4>
          <ul>
            {links.map((item) => {
              return (
                <Link key={item.name} to={item.link}>
                  <li key={item.name}>{item.name}</li>
                </Link>
              );
            })}
          </ul>
        </div>
        <div className="footer__main__item">
          <h4>Product Categories</h4>
          <ul>
            {productCategories.map((item, i) => {
              return (
                <Link key={item.name} to={item.link}>
                  <li>{item.name}</li>{" "}
                </Link>
              );
            })}
          </ul>
        </div>

        <div className="footer__main__item">
          <h4>Contact Info</h4>

          <div className="footer__main__item__info">
            <i class="bx bx-envelope"></i>
            <a href="mailto:chaolcarington1@gmail.com">
              chaolcarington1@gmail.com
            </a>
          </div>
          {/* <div className="footer__main__item__info">
            <i class="bx bx-phone"></i>
            <a href="tel:+2347043487270">+234 704 348 7270</a>
          </div> */}

          <div className="footer__main__item__info">
            <i class="bx bx-phone"></i>
            <p style={{ margin: 0 }}>
              <a href="tel:+2347041410503">+234 704 1410 503</a>
            </p>
          </div>
          <div className="footer__main__item__info">
            <i class="bx bx-phone"></i>
            <p style={{ margin: 0 }}>
              <a href="tel:+2349052070322">+234 905 2070 322</a>
            </p>
          </div>
          <div className="footer__main__item__info">
            <i class="bx bx-phone"></i>
            <p style={{ margin: 0 }}>
              <a href="tel:+2348133374900">+234 813 3374 900</a>
            </p>
          </div>
          <div className="footer__main__item__info">
            <i class="bx bx-location-alt-2"></i>
            <span>
              NO 22, 14 Road, Corner Shop, Gwarinpa Estate, Abuja, Nigeria.
            </span>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div>
          Copyright © {new Date().getFullYear()}{" "}
          <span>Chaol Carington Ltd</span>. All Rights Reserved.{" "}
          <span style={{ marginLeft: 10, color: "#333" }}>
            Powered by{" "}
            <a
              href="https://www.vibytsolutions.com.ng/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vibyt Solutions
            </a>
          </span>
        </div>
        <img src={payStackImg} alt="Paystack" />
      </div>
    </div>
  );
};

export default Footer;
